<script lang="ts">
    import Menu from './Menu.svelte';    
    import { createStores, setConfiguration, setSVGTextSize } from './createContext';
    import { getConfiguration, getGetSVG, getState, getZoomToFit } from './context';
    import Debug from './Debug.svelte';
    import { onMount } from "svelte";
    import { file_load } from './actions/file';
    import type { MachineState } from './state/machineState';
    import MealySim from './mealy/MealySim.svelte';
    import { configurations } from './configuration';
    import { EditMode } from './state/uiState';
    import { machine_startExecution } from './actions/machine';
    import DialogNewAutomaton from './dialog/DialogNewAutomaton.svelte';
    import { dialog_openNewAutomaton } from './actions/dialog';
	import { tick } from 'svelte';
    import { fullscreen_toggle } from './actions/ui';
    import { animation_setProgress, animation_stopTransition } from './state/animation';
    import PopUpMessage from './PopUpMessage.svelte';

    
    export let fileUrl;
    export let configurationName = 'full';
    export let debug = false;
    export let zoomToFitOnStart = false;
    export let system = '';
    
    createStores(system);
    
    setConfiguration({
        ...configurations[configurationName],
        debug: debug
    });

    const conf = getConfiguration();
    const zoomToFit = getZoomToFit();
    const getSVG = getGetSVG();
    
    if (typeof(fileUrl) === 'string') {
		onMount(async () => {
			const res = await fetch(fileUrl);
			let fileContent = await res.text();

            let saveObject = JSON.parse(fileContent);
            state.set(file_load($state, saveObject));

            if (conf.startEditMode === EditMode.EXECUTION) {
                // TODO: Soll geprüft werden, ob der Automat fehlerfrei ist?
                state.set(machine_startExecution($state));
            }
            if (zoomToFitOnStart) {
                await tick();
                $zoomToFit();
            }
		});
    }
    
    if (system !== '') {

    }

    const state = getState();

    if (conf.startup.showNewAutomatonDialog) {
        state.set(dialog_openNewAutomaton($state));
    }

    function handleMachineProgramStateChange(event: CustomEvent<MachineState>) {
        // console.log('App - handleMachineProgramStateChange')
        state.set({
            ...$state,
            machineState: event.detail
        });
    }

    function handleResetClick() {
        state.set(machine_startExecution($state));
    }

    
    // für Abmessungen eines Textes bestimmen
    let textBBoxSVG: SVGTextElement;

    function svgTextSize(text: string) {
        textBBoxSVG.textContent = text;
        const bbox = textBBoxSVG.getBBox();
        return {
            height: bbox.height,
            width: bbox.width,
        }
    }

    setSVGTextSize(svgTextSize);

    function handleFullscreenClick() {
        const newState = fullscreen_toggle($state);
        state.set(newState);

        if (newState.fullscreen) {
            document.body.style["overflow-y"] = 'hidden'
        } else {
            document.body.style["overflow-y"] = ''
        }
    }

    function handleScreenshot() {
        const svgContent = $getSVG();
        const svgContentEncoded = encodeURIComponent(svgContent);

        var link = document.createElement('a');
        link.download = 'automat-screenshot.svg'
        link.href = 'data:image/svg+xml;charset=utf-8,' + svgContentEncoded;

        link.click();
    }
    
    const transitionDuration = 1000;
    function systick(timestamp) {
        // timestamp ist der Wert aus timeline.currentTime, der die Zeit in ms seit dem Start der Animation angibt
        // Dieser Wert wird nicht verwendet, da mir im Moment nicht klar ist, wie er richtig zu verwenden ist
        // vgl. https://github.com/microsoft/TypeScript/issues/54496
        // timeline wäre wohl besser, da alle requestAnimationFrame-Callbacks, die direkt nacheinander laufen, den gleichen Wert für currenTime bekommen

        const now = performance.now();
        // console.log('systick');
        requestAnimationFrame(systick);
        if ($state.machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION && $state.machineState.type === 'MachineStateMealy') {            
            if (now > $state.machineState.animation.startTimestamp + transitionDuration) {
                state.set(animation_stopTransition($state));
            } else {
                const progress = (now - $state.machineState.animation.startTimestamp) / transitionDuration;
                state.set(animation_setProgress($state, progress));
            }
        }
    }
    requestAnimationFrame(systick);
</script>

<!-- box-shadow: 5px 5px 5px; -->
<div 
    class:fullscreen={$state.fullscreen}
    style="height: 100%;"
>
    <div style="position: relative; height: 100%; display: flex; flex-direction: column; overflow-x: auto; overflow-y: hidden; box-sizing: border-box; background-color: #9bd8fd; border-radius: 10px; padding: 10px;">
        {#if conf.showMenu}
            <Menu 
                onScreenshot={handleScreenshot}
            />
        {/if}

        <div style="flex-grow: 1; position: relative;">
            {#if $state.machineState.type === 'MachineStateMealy'}
                <MealySim 
                    machineState={$state.machineState}
                    editMode={$state.machineState.uiState.editMode}
                    on:machineProgramStateChange={handleMachineProgramStateChange}
                    onToggleFullscreen={handleFullscreenClick}
                />
            {/if}

            {#if $state.machineState.type === 'MachineStateDEA'}
                <!-- <DEASim 
                    machineProgramState={$state.machineProgramState}
                    editMode={$state.uiState.editMode}
                /> -->
            {/if}

            <!-- {#if conf.showResetSimulationButton}
                <button
                    style="position: absolute; top: 20px; left: 20px;"
                    on:click={handleResetClick}
                    class="automaten-simulator-iconButton"
                >
                    <IconResetSimulation />
                </button>
            {/if} -->

            <!-- {#if $state.popUpMessgage.isVisible}
                <PopUpMessage 
                    message={$state.popUpMessgage.message}
                />
            {/if} -->
        </div>
        <!-- {#if $state.machineState.popUpMessage.isVisible}
            <PopUpMessage 
                message={$state.machineState.popUpMessage.message}
                
            />

        {/if} -->

        {#if conf.debug}
            <Debug />
        {/if}

        <DialogNewAutomaton />
    </div>
</div>

<svg width="0" height="0">
    <text bind:this={textBBoxSVG}></text>
</svg>

<style>
    :global(.automaten-simulator-iconButton) {
        margin: 0;
        padding: 4px;
        height: 40px;
        width: 40px;
        box-sizing: border-box;

        border: 1px solid #ccc;
        border-radius: 2px;
        color: #000000;

        background-color: #f0f0f0;
    }

    :global(.automaten-simulator-iconButton:hover) {
        background-color:#d6d6d6;
    }

    .fullscreen {
        position: fixed;
        width: 100vw;
        height: 100vH;
        top: 0;
        left: 0;
        z-index: 999;
    }
</style>